import { motion } from "framer-motion";
import { Calendar } from "lucide-react";

const BOOKING_URL = "https://agendamiento.reservo.cl/makereserva/agenda/v0XFJkK0p04Joq5h8h11dw79n3v0yK";

export const WhatsAppFloat = () => {
  return (
    <motion.a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="booking-float-button"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-neon-green text-black font-bold px-5 py-4 rounded-full shadow-lg hover:scale-105 transition-transform"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      style={{
        boxShadow: "0 0 20px rgba(0, 255, 0, 0.5), 0 0 40px rgba(0, 255, 0, 0.3)",
      }}
    >
      <Calendar className="w-6 h-6" />
      <span className="hidden sm:inline text-sm uppercase tracking-wide">Agenda tu clase</span>
    </motion.a>
  );
};

export default WhatsAppFloat;
